function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "play-summary-buttons-copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "steps",
  transform: "translate(-57.000000, 0.000000)",
  fill: "#4A4A4A"
}, /*#__PURE__*/React.createElement("g", {
  id: "steps-dark",
  transform: "translate(57.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(15.591755, 4.294787) rotate(90.000000) translate(-15.591755, -4.294787) translate(11.591755, -10.705213)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 2.54364801,
  cy: 2.7393824,
  r: 1.7906975
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-6",
  cx: 5.952374,
  cy: 8.34931643,
  r: 1.7906975
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  cx: 2.77588861,
  cy: 14.8191451,
  r: 1.7906975
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-3",
  cx: 5.7598911,
  cy: 21.4547867,
  r: 1.7906975
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-4",
  cx: 2.95843662,
  cy: 27.599277,
  r: 1.7906975
})))));

function SvgSteps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "10px",
    viewBox: "0 0 32 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.56bb6055.svg";
export { ForwardRef as ReactComponent };